import { wrappingInputRule } from '@tiptap/core';
import Blockquote from '@tiptap/extension-blockquote';

const inputRegex = /^\s*"\s$/;
const BlockquoteExtension = Blockquote.extend({
  addInputRules() {
    return [
      wrappingInputRule({
        find: inputRegex,
        type: this.type
      })
    ];
  }
});

export { BlockquoteExtension, inputRegex };
//# sourceMappingURL=BlockquoteExtension.js.map
